"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaletteConfigProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useSpectrumConditional = require("../hooks/useSpectrumConditional");
var _constants = require("./constants");
var _context = require("./context");
var _usePaletteOverrides = require("./usePaletteOverrides");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const defaultOverrides = {};
const PaletteConfigProvider = /*#__PURE__*/(0, _react.memo)(({
  value: paletteOverrides = defaultOverrides,
  children
}) => {
  const parentPaletteOverrides = (0, _usePaletteOverrides.usePaletteOverrides)();

  // Construct the defaultPalette with color overrides based on the current spectrum
  const defaultPalette = (0, _useSpectrumConditional.useSpectrumConditional)({
    light: _constants.defaultPalette,
    dark: _constants.darkDefaultPalette
  });

  // merge with parent overrides
  const overrides = (0, _react.useMemo)(() => Object.assign({}, parentPaletteOverrides, paletteOverrides), [paletteOverrides, parentPaletteOverrides]);
  const palette = (0, _react.useMemo)(() => Object.assign({}, defaultPalette, overrides), [overrides, defaultPalette]);
  return /*#__PURE__*/_react.default.createElement(_context.PaletteConfigContext.Provider, {
    value: palette
  }, /*#__PURE__*/_react.default.createElement(_context.PaletteOverridesContext.Provider, {
    value: overrides
  }, children));
});
exports.PaletteConfigProvider = PaletteConfigProvider;
PaletteConfigProvider.displayName = 'PaletteProvider';